// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar__SbI9j {
  width: 90%;
  margin: auto;
}

.Navbar_navbar-section__EMqem {
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}

.Navbar_icon__FkpfY {
  width: clamp(80px, 15vw, 170px);
  padding-top: 10px;
  height: auto;
  cursor: pointer;
}

.Navbar_burger__tRV5m {
  display: none;
  cursor: pointer;
  color: white;
  z-index: 999;
}

.Navbar_navbar-items__pj0xS {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(40px, 3vw, 24px);
  margin: 0;
  padding: 0;
}
.Navbar_navbar-items__pj0xS a {
  text-decoration: none;
  color: white;
  font-size: clamp(16px, 2.5vw, 24px);
  transition: color 0.3s ease;
  font-family: "Roboto", sans-serif;
}
.Navbar_navbar-items__pj0xS a:hover {
  color: #4C6D59;
  cursor: pointer;
}
.Navbar_navbar-items__pj0xS a:active {
  box-shadow: 0 1px 0 #4C6D59;
}

/* Responsive Burger Styles */
@media (max-width: 1000px) {
  .Navbar_burger__tRV5m {
    display: block;
  }
  .Navbar_navbar-items__pj0xS {
    position: fixed;
    top: 0;
    right: 0;
    background: linear-gradient(145deg, #1e1e1e, #2e2e2e);
    opacity: 0.9;
    height: 100vh;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 998;
  }
  .Navbar_navbar-items__pj0xS {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: clamp(40px, 3vw, 24px);
    margin: 0;
    padding: 0;
  }
  .Navbar_navbar-items__pj0xS.Navbar_open__jGM4K {
    transform: translateY(0%);
  }
}
.Navbar_active-link__0ySx0 {
  color: #4C6D59 !important;
  font-weight: bold;
  border-bottom: 2px solid #4C6D59;
}`, "",{"version":3,"sources":["webpack://./src/Navbar/Navbar.module.scss"],"names":[],"mappings":"AAAA;EAEE,UAAA;EACA,YAAA;AAAF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAKA;EACE,+BAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;AAFF;AAKE;EACE,qBAAA;EACA,YAAA;EACA,mCAAA;EACA,2BAAA;EACA,iCAAA;AAHJ;AAKI;EACE,cAAA;EACA,eAAA;AAHN;AAMI;EACE,2BAAA;AAJN;;AASA,6BAAA;AACA;EACE;IACE,cAAA;EANF;EASA;IACE,eAAA;IACA,MAAA;IACA,QAAA;IACA,qDAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,4BAAA;IACA,sCAAA;IACA,YAAA;EAPF;EAUA;IACE,gBAAA;IACA,aAAA;IACA,eAAA;IACA,uBAAA;IACA,2BAAA;IACA,SAAA;IACA,UAAA;EARF;EAWA;IACE,yBAAA;EATF;AACF;AAYA;EACE,yBAAA;EACA,iBAAA;EACA,gCAAA;AAVF","sourcesContent":[".navbar {\n  //background-color: #4C6D59;\n  width: 90%;\n  margin: auto;\n\n}\n\n.navbar-section {\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  position: relative;\n\n}\n\n.icon {\n  width: clamp(80px, 15vw, 170px);\n  padding-top: 10px;\n  height: auto;\n  cursor: pointer;\n}\n\n.burger {\n  display: none;\n  cursor: pointer;\n  color: white;\n  z-index: 999;\n}\n\n.navbar-items {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: clamp(40px, 3vw, 24px);\n  margin: 0;\n  padding: 0;\n\n\n  a {\n    text-decoration: none;\n    color: white;\n    font-size: clamp(16px, 2.5vw, 24px);\n    transition: color 0.3s ease;\n    font-family: 'Roboto', sans-serif;\n\n    &:hover {\n      color: #4C6D59;\n      cursor: pointer;\n    }\n\n    &:active {\n      box-shadow: 0 1px 0 #4C6D59;\n    }\n  }\n}\n\n/* Responsive Burger Styles */\n@media (max-width: 1000px) {\n  .burger {\n    display: block;\n  }\n\n  .navbar-items {\n    position: fixed;\n    top: 0;\n    right: 0;\n    background: linear-gradient(145deg, #1e1e1e, #2e2e2e);\n    opacity: 0.9;\n    height: 100vh;\n    width: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    transform: translateY(-100%);\n    transition: transform 0.3s ease-in-out;\n    z-index: 998;\n  }\n\n  .navbar-items {\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: clamp(40px, 3vw, 24px);\n    margin: 0;\n    padding: 0;\n  }\n\n  .navbar-items.open {\n    transform: translateY(0%);\n  }\n}\n\n.active-link {\n  color: #4C6D59 !important; // Your green color\n  font-weight: bold;\n  border-bottom: 2px solid #4C6D59;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__SbI9j`,
	"navbar-section": `Navbar_navbar-section__EMqem`,
	"icon": `Navbar_icon__FkpfY`,
	"burger": `Navbar_burger__tRV5m`,
	"navbar-items": `Navbar_navbar-items__pj0xS`,
	"open": `Navbar_open__jGM4K`,
	"active-link": `Navbar_active-link__0ySx0`
};
export default ___CSS_LOADER_EXPORT___;
